import { Box } from '@chakra-ui/react';
import {Routes,Route} from 'react-router-dom';
import { memo } from 'react';
import {default as DefermentRequest} from './DefermentRequest';
import {default as TranscriptRequest} from './TranscriptRequest';
import {default as ChangeEmailRequest} from './ChangeEmailRequest'
import {default as PictureApproval} from './PictureApproval'




export const DefaultApprovals = () =>{
  return <div>
    Approvals
  </div>
}


const Approvals = () => {
  return (
    <Routes>
      <Route path="/" element={<ChangeEmailRequest  />}/>
      <Route path="/deferment-request" element={<DefermentRequest />} />
      <Route path="/transcript-request" element={<TranscriptRequest />} />
      <Route path="/change-email-request" element={<ChangeEmailRequest />} />
      <Route path="/picture-approval" element={<PictureApproval />} />
    </Routes>
  )
}

export default memo(Approvals);